(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-utilities"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lumenelle-country-selector')) {
    customElements.define('lumenelle-country-selector', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-ready')) return;
        const form = this.querySelector('form');
        const select = this.querySelector('select');
        if (!form || !select) return;
        this.setAttribute('data-ready', '');
        this.querySelector('button[type="submit"]').hidden = true;
        select.addEventListener('change', () => form.requestSubmit());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
